import axios from "axios";
import Interceptors from "@/utils/interceptors";
import store from "@/store";
import router from "@/router";

const interceptor = new Interceptors();

axios.interceptors.request.use(function(config) {
   if (interceptor.needClientId(config)) {
      config.params = { ...config.params, ...interceptor.getParam() };
   }
   config.url = interceptor.isClient(config);
   return config;
});

axios.interceptors.response.use(
   response => response,
   error => {
      if (!error.response) {
         // erro de conexão, timeout, DNS, servidor parado, etc.
         store.commit("setAlert", {
            text: "Não foi possível conectar ao servidor. Tente novamente mais tarde.",
            color: "error"
         });
         return Promise.reject(error);
      }

      const status = error.response ? error.response.status : null;
      if (status === 401) {
         localStorage.removeItem("token");
         store.commit("setUserAuthenticated", false);
         router.push({
            name: "login",
            params: { organization: localStorage.organization || "fintask" }
         });
         store.commit("setAlert", {
            text: "Sessão expirada. Faça login novamente.",
            color: "error"
         });
         return Promise.reject(error);
      }
      if (status >= 500) {
         store.commit("setAlert", {
            text: "Servidor fora do ar. Tente novamente mais tarde.",
            color: "error"
         });
      }
      return Promise.reject(error);
   }
);
